export const APP_LANDING_PRIORITY = [
  "feedback",
  "digital-menu",
  "booking-engine",
  "hms",
  "channel-manager",
  "office",
];

export const APP_ROUTE_MAP = {
  feedback: "/feedback",
  "digital-menu": "/digital-menu",
  "booking-engine": "/booking-engine",
  hms: "/hospitality",
  "channel-manager": "/channel-manager",
  office: "/employee-dashboard",
};

export const normalizeAppAccess = (apps) => {
  if (!Array.isArray(apps)) return [];
  return apps
    .map((app) => String(app || "").trim().toLowerCase())
    .filter(Boolean);
};

export const getDefaultRouteFromAppAccess = (appAccess = []) => {
  const normalizedApps = normalizeAppAccess(appAccess);

  for (const appKey of APP_LANDING_PRIORITY) {
    if (normalizedApps.includes(appKey)) {
      return APP_ROUTE_MAP[appKey];
    }
  }

  // safe fallback
  return "/employee-dashboard";
};

export const persistLoginSession = (d, options = {}) => {
  const { rememberMe = false, email = "", password = "" } = options;

  localStorage.setItem("token", d.accessToken || "");
  localStorage.setItem("dateFormat", d.dateformat || "");
  localStorage.setItem("dateFormatWithTime", d.dateFormatWithTime || "");
  localStorage.setItem("type", d.usertype || "");
  localStorage.setItem("username", d.userfullname || "");
  localStorage.setItem("empid", d.empid || "");
  localStorage.setItem("userid", d.userid || "");
  localStorage.setItem("useremail", d.useremail || "");
  localStorage.setItem("gender", d.gender || "");
  localStorage.setItem("empcode", d.empcode || "");
  localStorage.setItem("profilepic", d.profilepic || "");
  localStorage.setItem("companyid", d.companyid || "");
  localStorage.setItem("currencycode", d.currency || "");
  localStorage.setItem("colorschema", "orange");
  localStorage.setItem("layout", "twocolumn");
  localStorage.setItem("layoutwidth", "fixed");
  localStorage.setItem("layoutpos", "fluid");
  localStorage.setItem("topbartheme", "light");
  localStorage.setItem("layoutSized", "default");
  localStorage.setItem("layoutStyling", "default");
  localStorage.setItem("layoutSidebarStyle", "dark");
  localStorage.setItem("business_date", d.business_date || "");
  localStorage.setItem("companylogo", d.logo || "");
  localStorage.setItem("posbusiness_date", d.posBusinessdate || "");
  localStorage.setItem("company", d.company || "");
  localStorage.setItem("app_access", JSON.stringify(d.app_access || []));

  localStorage.removeItem("selectedRooms");
  localStorage.removeItem("billingSummary");
  localStorage.removeItem("searchState");
  localStorage.removeItem("searchParams");
  localStorage.removeItem("filteredRooms");

  if (rememberMe) {
    localStorage.setItem("email", email);
    localStorage.setItem("password", password);
  } else {
    localStorage.removeItem("email");
    localStorage.removeItem("password");
  }
};

export const finalizeLoginAndRedirect = ({
  responseData,
  navigate,
  notify,
  rememberMe = false,
  email = "",
  password = "",
}) => {
  persistLoginSession(responseData, {
    rememberMe,
    email,
    password,
  });

  const redirectTo = getDefaultRouteFromAppAccess(responseData.app_access || []);
  navigate(redirectTo);

  if (typeof notify === "function") {
    notify("success", `Welcome ${responseData.userfullname || "User"}!`);
  }
};